import ReactDOM from 'react-dom/client';
import { App } from 'src/App';
import { AppSensors } from 'src/AppSensors.tsx';
import { AppActuators } from 'src/AppActuators.tsx';
import { AppProviders } from 'src/AppProviders.tsx';
import { DatabaseProvider } from 'src/database/DatabaseProvider.tsx';
import { prepare, PrepareOptions } from 'src/prepareApp.tsx';
import { initProjectsPage } from 'src/projects/initProjectsPage.tsx';
import { SasSelectionType } from 'shared/projects/types.ts';
import { bootstrap } from 'src/bootstrap/bootstrap.ts';

export async function init({ app = 'valves', cdn, ...options }: PrepareOptions & {
    cdn: string;
    // @TODO cleanup prefix and baseURL
    prefix?: string;
    baseUrl?: string;
    app?: SasSelectionType;
}) {
    const { shadowRoot, base, offlineDatabase, databaseCache } = await prepare({
        ...options,
        bootstrapFn: bootstrap,
    });

    ReactDOM.createRoot(shadowRoot).render(
        <AppProviders
            {...base}
            renderDatabase={(children) => (
                <DatabaseProvider
                    assetDomain={cdn}
                    userSettings={base.userSettings}
                    databaseCache={databaseCache}
                    offlineDatabase={offlineDatabase}
                    uri={base.uri}
                >
                    {children}
                </DatabaseProvider>
            )}
        >
            {app === 'valves' && (<App/>)}
            {app === 'sensors' && (<AppSensors/>)}
            {app === 'actuators' && (<AppActuators/>)}
        </AppProviders>,
    );
}

window.vss = {
    init,
    initProjectsPage,
};
